// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import dtinsEntity from './entities/dtins.json';
import dtinsMenu from '../pages/dtins/menu.json';
import dtinsFullForm from '../pages/dtins/forms/full.json';
import dtinsContextForm from '../pages/dtins/forms/context.json';
import dtinsMiniForm from '../pages/dtins/forms/mini.json';
import dtinsLookupForm from '../pages/dtins/forms/lookup.json';
import dtinsTableView from '../pages/dtins/views/table.json';
import dtinsStagesView from '../pages/dtins/views/stages.json';
import dtinsCardsView from '../pages/dtins/views/cards.json';
import dtinsInlineView from '../pages/dtins/views/inline.json';
import dtinsBacklogView from '../pages/dtins/views/backlog.json';
import dtinsSplitView from '../pages/dtins/views/split.json';
import dtinsCalendarView from '../pages/dtins/views/calendar.json';
import dtinsDashboardView from '../pages/dtins/views/dashboard.json';

/** Тип запису «Інсайт» зі сторінками пакета: меню, форми та подання з pages/dtins/. */
export const dtinsDefinition: IRecordTypeDefinition = {
  ...dtinsEntity,
  views: assembleViewSet({
      table: dtinsTableView,
      stages: dtinsStagesView,
      cards: dtinsCardsView,
      inline: dtinsInlineView,
      backlog: dtinsBacklogView,
      split: dtinsSplitView,
      calendar: dtinsCalendarView,
      dashboard: dtinsDashboardView,
  }),
  form: dtinsFullForm,
  forms: { full: dtinsFullForm, context: dtinsContextForm, mini: dtinsMiniForm, lookup: dtinsLookupForm },
  menu: dtinsMenu,
} as IRecordTypeDefinition;
